import SmoothScroll from "smooth-scroll/dist/smooth-scroll.polyfills.js"

export let scroll
export const smothScrollInit = () => {
  scroll = new SmoothScroll("a[data-smooth]", {
    header: ".header",
    speedAsDuration: true,
    durationMax: 1000
  })
}
